import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StepperService {
  private _isLoginButton = new BehaviorSubject<boolean>(false);
  private _isRegisterButton = new BehaviorSubject<boolean>(false);
  private _changeButton = new BehaviorSubject<boolean>(false);
  private _loading = new BehaviorSubject<boolean>(false);
  private _hasAcceptedTerms = new BehaviorSubject<boolean>(false);
  private _hasAcceptedMarketingConsent = new BehaviorSubject<boolean>(false);
  private _isCompany = new BehaviorSubject<boolean>(false);
  
  private _currentStep = new BehaviorSubject<number>(0);
  private _currentSubStep = new BehaviorSubject<number>(0);
  private _region = new BehaviorSubject<string>('');

  isLoginButton$ = this._isLoginButton.asObservable();
  isRegisterButton$ = this._isRegisterButton.asObservable();
  changeButton$ = this._changeButton.asObservable();
  loading$ = this._loading.asObservable();
  hasAcceptedTerms$ = this._hasAcceptedTerms.asObservable();
  hasAcceptedMarketingConsent$ = this._hasAcceptedMarketingConsent.asObservable();
  isCompany$ = this._isCompany.asObservable();
  currentStep$ = this._currentStep.asObservable();
  currentSubStep$ = this._currentSubStep.asObservable();
  region$ = this._region.asObservable();

  stepButtonFn: ((direction: string) => void) | null = null;
  disableNextFn: (() => boolean) | null = null;
  isLastStepFn: (() => boolean) | null = null;
  loginFromStepperFn: (() => void) | null = null;
  registerFromStepperFn: (() => void) | null = null;

  setIsLoginButton(value: boolean) { this._isLoginButton.next(value); }
  setIsRegisterButton(value: boolean) { this._isRegisterButton.next(value); }
  setChangeButton(value: boolean) { this._changeButton.next(value); }
  setLoading(value: boolean) { this._loading.next(value); }
  setHasAcceptedTerms(value: boolean) { this._hasAcceptedTerms.next(value); }
  setHasAcceptedMarketingConsent(value: boolean) { this._hasAcceptedMarketingConsent.next(value); }
  setIsCompany(value: boolean) { this._isCompany.next(value); }

  setCurrentStep(value: number) { this._currentStep.next(value); }
  setCurrentSubStep(value: number) { this._currentSubStep.next(value); }
  setRegion(value: string) { this._region.next(value); }

  get currentStep(): number { return this._currentStep.value; }
  get currentSubStep(): number { return this._currentSubStep.value; }
  get region(): string { return this._region.value; }
  get isLoginButton(): boolean { return this._isLoginButton.value; }
  get isRegisterButton(): boolean { return this._isRegisterButton.value; }
  get changeButton(): boolean { return this._changeButton.value; }
  get loading(): boolean { return this._loading.value; }
  get hasAcceptedTerms(): boolean { return this._hasAcceptedTerms.value; }
  get hasAcceptedMarketingConsent(): boolean { return this._hasAcceptedMarketingConsent.value; }
  get isCompany(): boolean { return this._isCompany.value; }

  registerFunctions(functions: {
    stepButton: (direction: string) => void;
    disableNext: () => boolean;
    isLastStep: () => boolean;
    loginFromStepper: () => void;
    registerFromStepper: () => void;
  }) {
    this.stepButtonFn = functions.stepButton;
    this.disableNextFn = functions.disableNext;
    this.isLastStepFn = functions.isLastStep;
    this.loginFromStepperFn = functions.loginFromStepper;
    this.registerFromStepperFn = functions.registerFromStepper;
  }

  isButtonDisabled(): boolean {
    return this.currentStep === 1 && this.currentSubStep === 1;
  }
}